import { IVehicleResource } from "../models/vehicle";


export const isVehicle = (value: any): value is IVehicleResource => {
    return "licensePlate" in value;
}
